'use client';

import styles from '~/styles/components/author/related-authors.module.scss';
import { Author } from 'types';

import { updateFirestoreDoc } from '~/clients/firebase/client';
import { arrayUnion } from 'firebase/firestore';
import Button from '~/components/button';
import Input from '~/components/form/input';
import { authorNameToSlug } from 'sdk';
import { useState } from 'react';
import Image from 'next/image';
import { images } from 'sdk';
import Links from '~/lib/helpers/link-helper';
import Link from 'next/link';

import CloseSVG from '~/assets/svg/icons/close';
import COLORS from '~/lib/helpers/color-helper';
import { useGlobalState } from '../../state';

interface RelatedAuthorHeaderProps {
  author: Author;
  related_authors: Author[];
}

export default function RelatedAuthors({
  author,
  related_authors,
}: RelatedAuthorHeaderProps) {
  const { state } = useGlobalState();
  const user = state?.user?.data;
  const isAdmin = user?.isAdmin;
  const [addAuthor, setAddAuthor] = useState('');

  function handleAuthorChange(event: any) {
    setAddAuthor(event.target.value);
  }

  async function handleAddAuthor2(e: any) {
    try {
      const index_value = author.related_authors.length + 1;
      const slug = authorNameToSlug(addAuthor);
      await updateFirestoreDoc('author_content', author.id, {
        related_authors: arrayUnion({
          author_fullname: addAuthor,
          author_slug: slug,
          index: index_value,
        }),
        updated_by: user?.name,
        updated_at: new Date(),
      });
      alert(
        addAuthor +
        ' is now a Related Author of -- ' +
        author?.fullname +
        '. Hit REFRESH to see the author and image.'
      );
      return;
    } catch (e) {
      // err
    }
  }

  async function deleteRelatedAuthor2(index_value: number) {
    const author_slug = related_authors[index_value].id;

    //remove  from author_slug from  author.related_authors array
    const index = author.related_authors?.findIndex(
      (a) => a?.author_slug === author_slug
    );
    author.related_authors.splice(index, 1);
    try {
      await updateFirestoreDoc('author_content', author.id, {
        related_authors: author.related_authors,
        updated_by: user?.name,
        updated_at: new Date(),
      });
      alert(
        author_slug +
        ' is no longer a Related Author of -- ' +
        author?.fullname +
        '. Hit REFRESH to see the author and image.'
      );
    } catch (e) {
      console.log(e);
    }
  }

  function renderRelatedAuthors2() {
    related_authors = related_authors.filter(function (el) {
      return el != null;
    });

    return (
      <>
        <div className={styles['related_author-row']}>
          {related_authors?.map((a, i) => (
            <div key={a.id} className={styles['related_author-tile']}>
              <div>
                {isAdmin && (
                  <div
                    className={styles['related_author-onClose']}
                    onClick={() => deleteRelatedAuthor2(i)}
                  >
                    <CloseSVG strokeColor={COLORS.copyLight} />
                  </div>
                )}
                <Link
                  href={
                    Links.author.slug({
                      slug: a?.id || (author as any)?.objectID,
                    }).pathname
                  }
                  target='_blank'
                >
                  <Image
                    src={
                      images(a?.photo_url || 'author_images/blank-avatar.jpeg')
                        .user.profileImage
                    }
                    alt='Author image'
                    width={130}
                    height={130}
                    className={styles['author-img']}
                    unoptimized
                  />
                </Link>
              </div>
              <div className={styles['author-name']}>
                <h1>{a?.fullname} </h1>
              </div>
            </div>
          ))}
          {isAdmin && (
            <div className={styles['related_author-admin']}>
              <Input
                className={styles['related_author-input']}
                onChange={handleAuthorChange}
                placeholder='add an author (i.e. Stephen King)'
              />
              <Button
                className={styles['related_author-addbutton']}
                onPress={handleAddAuthor2}
                text='Add'
              />
            </div>
          )}
        </div>
      </>
    );
  }

  async function handleDeleteRelatedAuthor(
    author: Author,
    index_value: number,
    slug: string
  ) {
    author.related_authors.splice(index_value, 1);
    try {
      await updateFirestoreDoc('author_content', author.id, {
        related_authors: author.related_authors,
        updated_by: user?.name,
        updated_at: new Date(),
      });
    } catch (e) {
      console.log(e);
    }

    alert(slug + ' deleted');
    const index = related_authors?.findIndex((a) => a?.id === slug);
    if (index > -1) {
      related_authors.splice(index, 1);
    }
    return;
  }

  return (
    <>
      <div className={styles['related_author-title']}>
        <p> Similar authors</p>
      </div>
      <div>
        {/* {renderRelatedAuthors()} */}
        {renderRelatedAuthors2()}
      </div>
    </>
  );
}
